import React, { useState, useEffect } from "react";
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import RpmLineChart from "./rpmlinegraph"; // Assuming this component can handle both BPP and WLM data
import api from "../../api/api";
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import { useSelector } from "react-redux";
import ToastMessage from "../../utils/mui/righttoptoast";
const RpmGraphs = ({selectedCard ,notes ,fetchRpmNote ,tabs,setSelectedTab,selectedTab}) => {
    const [openToast, setOpenToast] = useState(false);
      const [toastMessage, setToastMessage] = useState('');

      const [toastSeverity, setToastSeverity] = useState('success');
  const [bppData, setBppData] = useState({ resdata: []  });
  const [wlmData, setWlmData] = useState({ resdata: [] });
  const [dataLoading, setDataLoading] = useState(false);
  const [bppSyncData, setBppSyncData] = useState([]);
  const practiseid = window.getPracticeId();

  const [authorize,setAuthorize]=useState(null)
  const rpmscreenprev = useSelector((state) => state.userPrivileges.rpm);
  const onSelectTab = (index) => {
    setSelectedTab(index);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };
  // Fetch data for both BPP and WLM when the component mounts or when the selectedCard changes
  useEffect(() => {
    fetchBppData();
    fetchWlmData();
   
  }, [selectedCard]);


  // Fetch BPP data function
  const fetchBppData = async () => {
    setDataLoading(true); // Set data loading to true
    try {
      const response = await api.post(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/bpp-master`,{});

      if (response.status === 200) {
        setBppData(response); // Assuming response data is an array of BPP readings
        console.log('Fetched BPP Data:', response);
        
      } else {
        setBppData([]); // Reset the data if the response is not successful
      }
    } catch (error) {
      console.log('Error fetching BPP data:', error);
      setBppData([]); // Reset data in case of error
    }finally{
      setDataLoading(false)
    }
  };
  // ${selectedCard.patientid}
  // Fetch WLM data function
  const fetchWlmData = async () => {
    setDataLoading(true); // Set data loading to true
    try {
      const response = await api.post(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/wlm-master`,{});

      if (response.status === 200) {
        setWlmData(response); // Assuming response data is an array of WLM readings
        console.log('Fetched WLM Data:', response);
      } else {
        setWlmData([]); // Reset the data if the response is not successful
      }
    } catch (error) {
      console.log('Error fetching WLM data:', error);
      setWlmData([]); // Reset data in case of error
    } finally {
      setDataLoading(false); // Set data loading to false
    }
  };

  const fetchBppSync = async (selectedCard) => {
    try {
      const payload = {
        OmronAPI: false,
        measurementCount: 0
      };
      const response = await api.post(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/bpp-sync`, payload);
      if (response.status === 200) {
        setBppSyncData(response.data); // Set the state with the fetched data
setToastMessage(`Refresh Successful ${response.message} ${response?.measurementcount}`);


    setToastSeverity('success');
    setOpenToast(true);
    fetchBppData()
      } else {
        setBppSyncData([]); // Reset data if the response is not 200
      }
    } catch (error) {
      console.log('Error fetching data:', error);
      setBppSyncData([]); // Reset data if error occurs
    } finally {
    }
  };

  const fetchAuthorized = async (selectedCard) => {
    try {
      console.log('Fetching data for patient ID:', selectedCard.patientid); // Log the patient ID for debugging
      const response = await api.put(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/authorize`);
    // 
      if (response.status === 200) {
        setAuthorize(response.data);
        const redirectUrl = `https://prd-oauth-website.ohiomron.com/connect/authorize?client_id=brainymedcare-api&response_type=code&scope=weight+bloodpressure+openid+offline_access&redirect_uri=https%3A%2F%2Fwapi.brainymed.com%2Fomron&state=${practiseid}_1_${selectedCard.patientid}`;
        window.open(redirectUrl, '_blank');
      } else {
        setAuthorize([]);
      }
    } catch (error) {
      console.log('Error fetching data:', error);
      setAuthorize([]); // If error occurs, reset the notes
    } finally {
    }
  };

  return (
    <div className="w-full flex flex-col gap-4 ">
      <div className="flex justify-between w-full">
      <div className="flex gap-4 block">
       <div className="flex ml-2">
        {tabs.map((tab, index) => (
          <div
            key={index}
            onClick={() => onSelectTab(index)}
            className={`[font-family:'Inter-Regular',Helvetica] w-[60px] tracking-[0] text-lg  font-normal whitespace-nowrap leading-5 cursor-pointer ${
              selectedTab === index
                ? "text-[black] bg-[#FFF7ED] border-b-2 border-[#e17954] py-1"
                : "text-[#1d2951]  rounded py-1"
            }`}
            style={{ left: `${5 + index * 50}px`, fontSize: "15px" }}
          >
            {tab.label}
          </div>
        ))}
      </div>
      <div className="cursor-pointer  rounded-lg" onClick={()=>fetchBppSync(selectedCard)}>
            <SyncOutlinedIcon />
      </div>
        
      </div>
    
      <div className="flex gap-2 items-center">
             <div className='text-xs text-[#6B7280]'><MailOutlineIcon/>{selectedCard.email}</div>
             {rpmscreenprev.includes("Authorize")&& <div >
            <button onClick={()=>fetchAuthorized(selectedCard)} className="px-3 py-2 text-xs font-font1 h-[5vh] rounded-md bg-[#16A34A] text-white">Authorize</button>
            </div>}
      </div>
         
       
      </div>
     
     
      <div className="w-full flex justify-center items-center flex-column border-[1.5px] border-gray-200 p-2 rounded-xl">
        <div className="w-full">
        {selectedTab === 0 ? (
          <div className="font-semibold text-start ml-2">Blood Pressure Readings</div>
        ) : (
          <div className="font-semibold text-start ml-2">Weight Loss Monitoring</div>
        )}
        </div>
     
<div className="w-full max-w-screen-xl mx-auto h-[30vh] lg:h-[50vh] flex justify-center items-center">
  <div className="w-full h-full">
    <RpmLineChart dataa={selectedTab === 0 ? bppData.data : wlmData.data} />
  </div>
</div>


      </div>

      {/* Data Table */}
      {dataLoading ? (
        <div>Loading...</div>
      ) : (
        <div className="overflow-x-auto  rounded-lg lg:max-h-[23vh] max-h-[28vh] overflow-y-auto mb-10" style={{scrollbarWidth:'none'}}>
          <table className="min-w-full border-collapse table-auto rounded">
            <thead className="bg-gray-50">
             
              <tr className="rounded-xl">
                <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">Date</th>
                {selectedTab === 0 ? (
        <>
          <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">Systolic</th>
          <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">Diastolic</th>
          <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">Pulse</th>
        </>
      ) : (
        <>
          <th className="border px-4 py-2 text-center text-[#71717A] text-sm font-semibold">Weight</th>
        
        </>
      )}
              </tr>
            </thead>
            <tbody>
              {(selectedTab === 0 ? (Array.isArray(bppData.resdata) ? bppData.resdata : []) : (Array.isArray(wlmData.resdata) ? wlmData.resdata : [])).map((reading, index) => (
                <tr key={index}>
                  <td className="border px-4 py-2 text-center text-[#09090B] text-[13px] font-semibold">{reading.datelabel}</td>
                  {selectedTab === 0 ? (
          <>
            <td className="border px-4 py-2 text-center text-[#E17954] text-[14px]">{reading.systolic}</td>
            <td className="border px-4 py-2 text-center text-[#E17954] text-[14px]">{reading.diastolic || 'N/A'}</td>
            <td className="border px-4 py-2 text-center text-[#2563EB] text-[14px]">{reading.pulse || 'N/A'}</td>
          </>
        ) : (
          <>
            <td className="border px-4 py-2 text-center text-[#E17954] text-[14px]">{reading.weight || 'N/A'}</td>
 
          </>
        )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
                   <ToastMessage
                message={toastMessage}
                severity={toastSeverity}
                open={openToast}
                handleClose={handleToastClose}
              />
    </div>
  );
};

export default RpmGraphs;
